import { TITLE_COLUMN } from './sorting';

const getSingleRow = (assignments, keys, title) => {
  const rowStart = { [TITLE_COLUMN]: title };

  if (!assignments) return {};
  const totalRow = assignments.reduce((acc, assignment) => {
    const { assignmentId } = assignment;
    const values = keys.reduce(
      (result, key) => ({
        ...result,
        [key]: assignment[key],
      }),
      {},
    );

    acc[assignmentId] = {
      ...values,
    };

    return acc;
  }, rowStart);
  return totalRow;
};

export default getSingleRow;



// WEBPACK FOOTER //
// ./src/components/Survey/helpers/getSingleRow.js